import { Navigate } from 'react-router-dom';
import { useSporforyaContext } from '../../context';

type Props = {
  children: JSX.Element;
};

const OwnerProtected = ({ children }: Props) => {
  const { userInfo } = useSporforyaContext();
  if (userInfo?.adminRole !== "superadmin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
};
export default OwnerProtected;
